export default "__VITE_ASSET__ee42fa7b__"